import { array } from "prop-types";
import { toast } from "react-toastify";
import { AI_RECRUITER, AI_RECRUITER_LOG, COMMON } from "../config/apiEndPoint";
import { GET, POST } from "config/api.config";

/**
 * Table + filter schema (same idea as `fetchJobCategoryTableAndFilterSchema` in CategoryModel).
 */
export const fetchAiRecruiterLogTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${AI_RECRUITER_LOG.GET_METADATA}/${data?._Id}`
      : `${AI_RECRUITER_LOG.GET_METADATA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** Alias — metadata GET only (used by consumers that only need columns). */
export const getAiRecruiterLogMetadata = fetchAiRecruiterLogTableAndFilterSchema;

/** List/filter POST — same idea as CategoryModel `submitFilterData`. */
export const submitAiRecruiterLogFilterData = async (data = {}) => {
  try {
    const response = await POST(AI_RECRUITER_LOG.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `ai-recruiter/call/trigger?candidateClientId=` — AI call trigger status for a candidate. */
export const getAiRecruiterCallTriggerStatus = async (candidateClientId) => {
  try {
    const id = String(candidateClientId ?? "").trim();
    if (!id) {
      toast.error("Candidate ID is required to load AI call status.");
      return null;
    }
    const response = await GET(AI_RECRUITER.CALL_TRIGGER_STATUS(id));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `ai-recruiter/call/trigger` — trigger AI recruiter call for a candidate. */
export const triggerAiRecruiterCall = async (data = {}) => {
  try {
    const candidateClientId = String(data?.candidateClientId ?? "").trim();
    const status = String(data?.status ?? "").trim();
    const aiAddOnCallTemplateId = String(data?.aiAddOnCallTemplateId ?? "").trim();
    if (!candidateClientId) {
      toast.error("Candidate ID is required to trigger an AI call.");
      return null;
    }
    const payload = { candidateClientId, status };
    if (aiAddOnCallTemplateId) {
      payload.aiAddOnCallTemplateId = aiAddOnCallTemplateId;
    }
    const response = await POST(AI_RECRUITER.CALL_TRIGGER_POST, payload);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** POST `ai-recruiter/move-to-schedule` — move selected candidates to AI recruiter schedule. */
export const moveCandidatesToAiRecruiterSchedule = async (payload = {}) => {
  try {
    const response = await POST(AI_RECRUITER.MOVE_TO_SCHEDULE, payload);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `common/ai-recruiter-notification-types` — dropdown for AI recruiter log filter. */
export const fetchAiRecruiterNotificationTypeOptions = async () => {
  try {
    const response = await GET(COMMON.AI_RECRUITER_NOTIFICATION_TYPES);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
